export default __webpack_public_path__ + "static/media/clock.d0a1433d.png";